import { css } from "@emotion/react";

import BentoItemContainer from "~/components/me/bento/containers/BentoItemContainer";
import BentoItemRow from "~/components/me/bento/containers/BentoItemRow";
import ContentWillCreateBanner from "~/components/me/bento/content/ContentWillCreateBanner";
import AccountSmall from "~/components/me/bento/content/account-small";
import CommittedDatabase from "~/components/me/bento/content/committed-database";
import ExamHistory from "~/components/me/bento/content/exam-history";
import { FussyAttestationCardHolder } from "~/components/me/bento/content/fussy-attestation";
import MembershipShortcut from "~/components/me/bento/content/membership-shortcut";
import PointReport from "~/components/me/bento/content/point-report";
import QuestLog from "~/components/me/bento/content/quest-log";
import QuestMemory from "~/components/me/bento/content/quest-memory";
import RadioResponseMemory from "~/components/me/bento/content/radio-response-memory";
import { useGraphqlClient } from "~/lib/client/hooks/useGraphqlClient";
import { useAppContext } from "~/pages/_app";

const PcBentoContents = () => {
  const client = useGraphqlClient();
  const { currentUser } = useAppContext();

  if (!client) return null;
  if (!currentUser) return null;

  return (
    <div css={rootStyle}>
      {/* row=1*/}
      <BentoItemRow>
        <BentoItemContainer size={{ width: 1, height: 1 }}>
          <AccountSmall client={client} />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 1, height: 1 }}>
          <PointReport client={client} />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 1, height: 1 }}>
          <QuestMemory client={client} />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 2, height: 1 }}>
          <QuestLog client={client} />
        </BentoItemContainer>
      </BentoItemRow>
      {/* row=2*/}
      <BentoItemRow>
        <BentoItemContainer size={{ width: 3, height: 1 }}>
          <CommittedDatabase client={client} />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 1, height: 1 }}>
          <RadioResponseMemory client={client} />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 1, height: 1 }}>
          <MembershipShortcut client={client} />
        </BentoItemContainer>
      </BentoItemRow>
      {/* row=3*/}
      <BentoItemRow>
        <BentoItemContainer size={{ width: 3, height: 1 }}>
          <ExamHistory client={client} />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 2, height: 1 }} empty>
          {null}
        </BentoItemContainer>
      </BentoItemRow>
      {/* row=4*/}
      <BentoItemRow>
        <FussyAttestationCardHolder client={client} />
      </BentoItemRow>
      {/* row=5*/}
      <BentoItemRow>
        <BentoItemContainer size={{ width: 3, height: 1 }}>
          <ContentWillCreateBanner />
        </BentoItemContainer>
        <BentoItemContainer size={{ width: 2, height: 1 }} empty>
          {null}
        </BentoItemContainer>
      </BentoItemRow>
    </div>
  );
};

const rootStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default PcBentoContents;
